import React, { useEffect } from 'react';
import { getMenuPath, escapeHtml } from '../utils/bannerUtils';

/**
 * 유형 6 - 리퀴드 글래스 (애플 스타일)
 * 원본: banner-glass fragment
 *
 * @param {string} title - 페이지 타이틀
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열
 * @param {string} subtitle - 서브타이틀
 * @param {string} bgGradient - 배경 그라디언트 (기본값: 기본 그라디언트)
 */
const BannerGlass = ({ title, breadcrumbPath, subtitle = '', bgGradient = '' }) => {
  useEffect(() => {
    // AOS 초기화
    if (typeof window.AOS !== 'undefined') {
      requestAnimationFrame(() => {
        window.AOS.refreshHard();
      });
    }
  }, []);

  const pageTitle = title || '페이지';
  const menuPath = getMenuPath(breadcrumbPath);
  const hasSubtitle = subtitle && subtitle.trim() !== '';
  // bgGradient prop은 현재 사용되지 않지만, 향후 사용을 위해 유지

  return (
    <>
      <style>
        {`
          .banner-glass {
            position: relative;
            padding: 30px 0px;
            overflow: hidden;
            background: #3d3d3d;
          }
          .banner-glass .container {
            position: relative;
            z-index: 2;
            text-align: center;
          }
          .banner-glass .banner-glass-card {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(40px) saturate(180%);
            -webkit-backdrop-filter: blur(40px) saturate(180%);
            border: 1px solid rgba(255, 255, 255, 0.18);
            border-radius: 24px;
            padding: 60px 50px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1),
                        inset 0 1px 0 rgba(255, 255, 255, 0.3);
            margin: 0 auto;
            position: relative;
            overflow: hidden;
          }
          .banner-glass .banner-glass-card::before {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
            animation: shimmer 8s ease-in-out infinite;
            pointer-events: none;
          }
          @keyframes shimmer {
            0%, 100% { transform: translate(0, 0) rotate(0deg); opacity: 0.3; }
            50% { transform: translate(30%, 30%) rotate(180deg); opacity: 0.6; }
          }
          .banner-glass .banner-title {
            font-size: 3.2rem;
            font-weight: 700;
            color: rgba(255, 255, 255, 0.95);
            margin-bottom: 20px;
            text-shadow: 0 2px 20px rgba(0, 0, 0, 0.2);
            letter-spacing: -1px;
            line-height: 1.2;
            position: relative;
            z-index: 1;
          }
          .banner-glass .banner-subtitle {
            font-size: 1.2rem;
            color: rgba(255, 255, 255, 0.85);
            margin-bottom: 30px;
            font-weight: 400;
            letter-spacing: 0.3px;
            line-height: 1.6;
            position: relative;
            z-index: 1;
          }
          .banner-glass .banner-breadcrumb {
            font-size: 0.95rem;
            color: rgba(255, 255, 255, 0.9);
            display: inline-block;
            padding: 12px 28px;
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(20px) saturate(180%);
            -webkit-backdrop-filter: blur(20px) saturate(180%);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 50px;
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1),
                        inset 0 1px 0 rgba(255, 255, 255, 0.3);
            font-weight: 500;
            letter-spacing: 0.5px;
            position: relative;
            z-index: 1;
            transition: all 0.3s ease;
          }
          .banner-glass .banner-breadcrumb:hover {
            background: rgba(255, 255, 255, 0.2);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15),
                        inset 0 1px 0 rgba(255, 255, 255, 0.4);
          }
          .banner-glass .banner-breadcrumb a {
            color: rgba(255, 255, 255, 0.95);
            text-decoration: none;
            transition: opacity 0.3s ease;
          }
          .banner-glass .banner-breadcrumb a:hover {
            opacity: 0.8;
          }
          @media (max-width: 768px) {
            .banner-glass {
              padding: 60px 0 50px;
            }
            .banner-glass .banner-glass-card {
              padding: 40px 30px;
              border-radius: 20px;
            }
            .banner-glass .banner-title {
              font-size: 2.2rem;
            }
            .banner-glass .banner-subtitle {
              font-size: 1rem;
            }
          }
        `}
      </style>
      <div className="banner-glass">
        <div className="container">
          <div className="banner-glass-card">
            <h1 className="banner-title" data-aos="fade-down" data-aos-delay="100">
              {escapeHtml(pageTitle)}
            </h1>
            {hasSubtitle && (
              <p className="banner-subtitle" data-aos="fade-up" data-aos-delay="150">
                {escapeHtml(subtitle)}
              </p>
            )}
            <div className="banner-breadcrumb" data-aos="fade-up" data-aos-delay="200">
              {menuPath}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerGlass;

